import { gql } from '@apollo/client';
import {
  LibraryBrandFoodBeverageFragment,
  LibraryBrandFoodBeverageMinifiedFragment,
} from './libraryBrandFoodBeverage';
import {
  ILibraryOpeningHours,
  LibraryOpeningHoursFragment,
} from './libraryOpeningHours';
import {
  ILibraryOpeningHoursException,
  LibraryOpeningHoursExceptionsFragment,
} from './libraryOpeningHoursException';
import { IMeetingPlaceSeoDescription } from '@/interfaces/meetingPlaceSeoDescription';
import {
  ILibrarySocialMediaLinks,
  LibrarySocialMediaLinksFragment,
} from './librarySocialMediaLinks';
import { TTenantTypes } from './meetingPlacePageTenantList';
import {
  ILibraryCategoryFoodBeverage,
  LibraryCategoryFoodBeverageFragment,
} from './libraryCategoryFoodBeverage';
import { LibraryCuisineTypeFragment } from './libraryCuisineType';
import { LibraryPriceLevelFragment } from './libraryPriceLevel';
import { BlockPdfAssetFragment } from './blockPdfAsset';
import { ICircularServicesTags } from './meetingPlacePageTenantShopItem';
import {
  LibraryBrandEntertainmentFragment,
  LibraryBrandEntertainmentMinifiedFragment,
} from './libraryBrandEntertainment';
import {
  LibraryBrandShopFragment,
  LibraryBrandShopMinifiedFragment,
} from './libraryBrandShop';

export interface IMeetingPlacePageTenantFoodBevItem {
  __typename: string;
  sys: {
    id: string;
    locale: string;
  };
  brand: any;
  name: string;
  slug: string;
  floorPlanIDs: string[];
  unitId?: string[];
  logo: any;
  description: any;
  contactDetails: any;
  coverImage: any;
  primaryCategory: any;
  secondaryCategoriesCollection: {
    items: ILibraryCategoryFoodBeverage[];
  };
  openingHours: ILibraryOpeningHours;
  openingHoursExceptionsCollection: { items: ILibraryOpeningHoursException[] };
  cuisine: any;
  priceLevel: any;
  hasOffer?: boolean;
  socialMediaLinks: ILibrarySocialMediaLinks;
  customizedSlug: string;
  // node_locale: string;
  seoDescription: IMeetingPlaceSeoDescription;
  giftCard: boolean;
  loyaltyCard: boolean;
  menu: any;
  isItAMultiBrandStore?: string;
  subShopsListTitle?: string;
  subShopItemCollection?: {
    items: TTenantTypes[];
  };
  hasEvent?: boolean;
  offerCampaignNames?: string[];
  circularServicesCollection: { items: ICircularServicesTags[] };
}

export const MeetingPlacePageTenantFoodBevItemFragment = gql`
  ${LibrarySocialMediaLinksFragment}
  ${BlockPdfAssetFragment}
  ${LibraryPriceLevelFragment}
  ${LibraryBrandFoodBeverageFragment}
  ${LibraryBrandShopFragment}
  ${LibraryBrandEntertainmentFragment}
  fragment MeetingPlacePageTenantFoodBevItem on MeetingPlacePageTenantFoodBeverage {
    __typename
    sys {
      id
      locale
    }
    floorPlanIDs
    unitId
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShop
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverage
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainment
      }
    }
    name
    slug
    logo {
      description
      url
      height
      width
    }
    description {
      json
    }
    # contactDetails {
    #   json
    # }
    coverImage {
      description
      url
      height
      width
    }
    # primaryCategory {
    #   ...LibraryCategoryFoodBeverage
    # }
    # secondaryCategoriesCollection(limit: 10) {
    #   items {
    #     ...LibraryCategoryFoodBeverage
    #   }
    # }
    # openingHours {
    #   ...LibraryOpeningHours
    # }
    # openingHoursExceptionsCollection {
    #   items {
    #     ... on LibraryOpeningHoursException {
    #       ...LibraryOpeningHoursExceptions
    #     }
    #   }
    # }
    # cuisineCollection(limit: 5) {
    #   items {
    #     ...LibraryCuisineType
    #   }
    # }
    priceLevel {
      ...LibraryPriceLevel
    }
    # socialMediaLinks {
    #   ...LibrarySocialMediaLinks
    # }
    seoDescription
    giftCard
    loyaltyCard
    menu {
      ...BlockPdfAsset
    }
  }
`;

export const MeetingPlacePageTenantFoodBevItemTenantInfoFragment = gql`
  ${LibraryCategoryFoodBeverageFragment}
  ${LibrarySocialMediaLinksFragment}
  ${LibraryOpeningHoursFragment}
  ${LibraryOpeningHoursExceptionsFragment}
  ${LibraryCuisineTypeFragment}
  fragment MeetingPlacePageTenantFoodBevItemTenantInfo on MeetingPlacePageTenantFoodBeverage {
    contactDetails {
      json
    }
    primaryCategory {
      ...LibraryCategoryFoodBeverage
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryFoodBeverage
      }
    }
    openingHours {
      ...LibraryOpeningHours
    }
    openingHoursExceptionsCollection {
      items {
        ... on LibraryOpeningHoursException {
          ...LibraryOpeningHoursExceptions
        }
      }
    }
    cuisineCollection(limit: 5) {
      items {
        ...LibraryCuisineType
      }
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
  }
`;

export const MeetingPlacePageTenantFoodBevItemMinifiedFragment = gql`
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryCategoryFoodBeverageFragment}
  fragment MeetingPlacePageTenantFoodBevItemMinified on MeetingPlacePageTenantFoodBeverage {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    logo {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryFoodBeverage
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryFoodBeverage
      }
    }
  }
`;

export const MeetingPlacePageTenantFoodBevItemMinifiedLogoFragment = gql`
  fragment MeetingPlacePageTenantFoodBevItemMinifiedLogo on MeetingPlacePageTenantFoodBeverage {
    __typename
    sys {
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandFoodBeverage {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
      ... on LibraryBrandEntertainment {
        sys {
          id
          locale
        }
        name
        slug
        logo {
          description
          url
          height
          width
        }
      }
    }
    logo {
      description
      url
      height
      width
    }
  }
`;

export const MeetingPlacePageTenantFoodBevListItemFragment = gql`
  ${LibraryCategoryFoodBeverageFragment}
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryPriceLevelFragment}
  ${LibraryCuisineTypeFragment}
  fragment MeetingPlacePageTenantFoodBevListItem on MeetingPlacePageTenantFoodBeverage {
    __typename
    sys {
      locale
      id
    }
    name
    brand {
      ... on LibraryBrandShop {
        ...LibraryBrandShopMinified
      }
      ... on LibraryBrandFoodBeverage {
        ...LibraryBrandFoodBeverageMinified
      }
      ... on LibraryBrandEntertainment {
        ...LibraryBrandEntertainmentMinified
      }
    }
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryFoodBeverage
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryFoodBeverage
      }
    }
    cuisineCollection(limit: 5) {
      items {
        ...LibraryCuisineType
      }
    }
    priceLevel {
      ...LibraryPriceLevel
    }
    giftCard
    loyaltyCard
  }
`;

